import isNil from 'lodash/isNil';
import strings from 'strings';

const hasValue = val => {
  if (isNil(val)) return false;
  if (Array.isArray(val)) return val.length > 0;
  if (typeof val === 'string') return val.trim() !== '';
  return true;
};

export const validateFilters = (filters, filtersDefinition) => {
  const defsByName = filtersDefinition.reduce((acc, def) => {
    acc[def.name] = def;
    return acc;
  }, {});

  return filtersDefinition.reduce((errors, filterDef) => {
    const currentValue = filters[filterDef.name];
    if (!hasValue(currentValue)) return errors;

    const requiredWith = Array.isArray(filterDef.requiredWith) ? filterDef.requiredWith : [];

    if (requiredWith.length === 0) return errors;

    const currentLabel = filterDef.title || filterDef.name;

    return requiredWith.reduce((innerErrors, dependencyName) => {
      if (innerErrors[dependencyName]) return innerErrors;

      const dependencyDefinition = defsByName[dependencyName];
      if (!dependencyDefinition) return innerErrors;

      const dependencyValue = filters[dependencyName];
      if (hasValue(dependencyValue)) return innerErrors;

      const dependencyLabel = dependencyDefinition.title || dependencyName;

      return {
        ...innerErrors,
        [dependencyName]: {
          message: strings.formatString(strings.shared.fields.requiredWith, {
            dependencyLabel,
            currentLabel
          })
        }
      };
    }, errors);
  }, {});
};

export const normalizeDependentFilters = dependent => {
  if (!dependent) return [];
  return Array.isArray(dependent) ? dependent : [dependent];
};
